// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__18fN4","clinicsSelect":"TableHeading_clinicsSelect__2-wlJ"};